"use strict";

var _classCallCheck = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Environment = /*#__PURE__*/function () {
  function Environment(configs) {
    _classCallCheck(this, Environment);

    this.configs = configs; //
  }

  _createClass(Environment, [{
    key: "getConfig",
    value: function getConfig(key) {
      return this.configs[key] || null;
    }
  }, {
    key: "setConfig",
    value: function setConfig(key, config) {
      this.configs[key] = config;
      return this;
    }
  }, {
    key: "extendConfig",
    value: function extendConfig(key, config) {
      this.configs[key] = Object.assign({}, this.configs[key], config);
      return this;
    }
  }]);

  return Environment;
}();

exports.Environment = Environment;